import {
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
  computed,
  inject,
} from '@angular/core';
import { PagesService } from '../pages.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ProducersService } from './producers.service';
import { handleImageError } from '../../shared/common/utils';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SeoService } from '../../shared/seo.service';
import { SEO_PAGES_CONFIG } from '../../shared/header/header.lists';
import { Pages } from '../../shared/types/common.enums';
import { Producer } from '../../shared/types/common.types';
@Component({
  selector: 'app-producers',
  imports: [RouterLink, CommonModule],
  templateUrl: './producers.component.html',
  styleUrl: './producers.component.scss'
})
export class ProducersComponent implements OnInit {

  //#region Services

  #producersService = inject(ProducersService);

  #seoService = inject(SeoService);

  #pagesService = inject(PagesService);

  #sanitizer = inject(DomSanitizer);

  //#endregion

  //#region Properties

  handleImageError = handleImageError;

  loadingProducers = computed(() => this.#producersService.isLoadingProducers());

  producersCards = computed(() => this.#config());

  producersFilter = computed(() => this.#getProducersNoFeatured());

  mainProducer = computed(() => this.#getMainProducer());

  //#endregion

  //#region Constructor

  constructor(@Inject(PLATFORM_ID) private platformId: any) {
    this.#seoService.setUpSEOTags(SEO_PAGES_CONFIG[Pages.producers]);
  }

  ngOnInit(): void {
    this.#pagesService.restartSideMenu();
    if (isPlatformBrowser(this.platformId))
      this.#producersService.getAllProducers();
  }

  //#endregion

  //#region Methods

  #truncateHtml(html: string, maxLength: number, url: string): SafeHtml {
    if (!isPlatformBrowser(this.platformId)) return '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    let charCount = 0;
    const truncateNode = (node: Node): boolean => {
      if (node.nodeType === Node.TEXT_NODE) {
        const textContent = node.textContent || '';
        if (charCount + textContent.length > maxLength) {
          const truncatedText = textContent.slice(0, maxLength - charCount) + '... ';
          node.textContent = truncatedText;
          return true;
        } else {
          charCount += textContent.length;
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        const childNodes = Array.from(node.childNodes);
        for (const childNode of childNodes) {
          if (truncateNode(childNode)) {
            return true;
          }
        }
      }
      return false;
    };

    truncateNode(tempDiv);

    let additionalText = `<a href="/pages/producers/${url}" class="fw-bold"> Read more</a></p>`;

    let truncatedHtml = tempDiv.innerHTML;
    if (tempDiv.innerHTML.includes('... </p>'))
      truncatedHtml = tempDiv.innerHTML.replace('... </p>', '... ' + additionalText);
    else
      truncatedHtml = tempDiv.innerHTML += additionalText;

    truncatedHtml = truncatedHtml.substring(0, truncatedHtml.indexOf(additionalText) + additionalText.length);
    truncatedHtml = truncatedHtml.replaceAll('<p>', '<p style="margin-bottom:0px;">');
    return this.#sanitizer.bypassSecurityTrustHtml(truncatedHtml);
  }

  #config() {
    const producers: Producer[] = this.#producersService.producersSignal();

    if (!producers)
      return [];

    return producers.map<Producer>((p: any) => {
      const desc = (p.description || '');
      const truncatedDescription = this.#truncateHtml(desc, p.isFeatured ? 300 : 100, p.detailUrl);
      p.description = truncatedDescription;
      return p
    });
  }

  checkProducer(name: string) {
    this.#producersService.setName(name)
  }

  #getMainProducer(): Producer | undefined {

    if (!this.producersCards().length)
      return undefined;

    return this.producersCards().find(x => x.isFeatured);
  }

  #getProducersNoFeatured() {
    return this.producersCards().filter(x => !x.isFeatured);
  }

  //#endregion
}
